<template>
  <a v-if="!isIssued"
     :style="{cursor: 'pointer'}"
     @click="$emit('issue-pass')"
  >
    <img class="menu-item-img icon-pdf"
         :src="iconPath('v_pass.svg')"
         alt="Выдать пропуск"/>
    Выдать пропуск
  </a>
</template>

<script>
export default {
  name: 'IssuePassButton',

  props: {
    isIssued: {
      type: Boolean
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }
}
</script>

<style scoped>

</style>
